import { createSlice } from "@reduxjs/toolkit";

export const mockInformHost = {
  active: false,
  informUrl: "192.168.220.76",
  informUrlSource: null
};

export const onInformHostSlice = createSlice({
  name: "onInformHost",
  initialState: {
    data: {
      resource: "informHost",
      data: { ...mockInformHost },
    },
  },
});

export default onInformHostSlice.reducer;